export const ABTests = {
  FORM_STEPS: 'ATP-6613',
}

export const LoginABTests = {
  FORM_VIEW: 'ATP-7800',
}
